import {ReactNode} from 'react';
import {ProductionStepMaterialCondition, ProductionStepMaterialConditionForm} from './production-step.models';
import {useForm} from '@tanstack/react-form';
import {EvInputField} from '../../form/EvInputField';
import {concatErrorString, ValidationError} from '../../errorhandling/errorHandling.model';
import {useProductionMachineList} from '../../production/machines/useProductionMachineListQuery';
import {EvNumberInputField} from '../../form/EvNumberInputField';

interface Props extends ValidationError {
  className?: string;
  condition?: ProductionStepMaterialCondition;
  formSubmit: (form: ProductionStepMaterialConditionForm) => void;
  children?: ReactNode;
}

export function ProductionStepMaterialForm(props: Props) {
  const form = useForm({
    defaultValues: {
      variation_id: props.condition?.material_variation.variation_id ?? '',
      group: props.condition?.group ?? null,
      production_machine_id: props.condition?.production_machine_id ?? null,
      rules: JSON.stringify(props.condition?.rules ?? {}, null, 2),
    },
    onSubmit: ({formApi}) => {
      props.formSubmit(formApi.state.values);
    },
  });

  const machineList = useProductionMachineList({sort: 'id', take: 500});
  return <form className={props.className} onSubmit={async e => {
    e.preventDefault();
    await form.handleSubmit(e);
  }}>
    <div className="p-2">
      <form.Field name="variation_id">
        {field =>
          <EvInputField type="text"
                        field={field}
                        errors={props.errors}
                        title={concatErrorString(props.errors, 'variation_id')}/>
        }
      </form.Field>
    </div>

    <div className="p-2">
      <form.Field name="group">
        {field =>
          <EvNumberInputField numberType="int"
                              nullable={true}
                              field={field}
                              title={concatErrorString(props.errors, 'group')}/>
        }
      </form.Field>
    </div>

    <div className="p-2">
      <form.Field name="production_machine_id">
        {field =>
          <EvInputField type="select"
                        field={field}
                        errors={props.errors}
                        title={concatErrorString(props.errors, 'production_machine_id')}>
            <option value={null}>-</option>
            {machineList.objects.map(m =>
              <option key={m.id} value={m.id}>{m.id} - {m.name}</option>)}
          </EvInputField>
        }
      </form.Field>
    </div>

    <div className="p-2">
      <form.Field name="rules">
        {field =>
          <EvInputField type="textarea"
                        rows={50}
                        field={field}
                        errors={props.errors}
                        title={concatErrorString(props.errors, 'rules')}/>
        }
      </form.Field>
    </div>
    <div>{props.children}</div>
  </form>;
}
